const icon = new URL('../../icons/sprite.png', import.meta.url).href

export default {
  type: 'sprite',
  description: 'sprite',
  group: '3D' /* line|shape|textAndMedia|chartAndGauge|table|container|dataSource|IoT|3D|warehouse|form|etc */,
  icon,
  model: {
    type: 'sprite',
    top: 100,
    left: 100,
    width: 200,
    height: 80,
    zPos: 40,
    depth: 10,
    fillStyle: '#ffffff',
    strokeStyle: '#999',
    lineWidth: 1,
    alpha: 1
  }
}
